import { AccessPointData, PermissionData } from '../api/types';

export const getMissingPermissions = (access: AccessPointData) =>
    (access?.permissions || []).filter(
        (
            permission: PermissionData // these can be missing from data (undefined), so !situation would not work
        ) =>
            permission.cardSituation === false ||
            permission.eLockSituation === false ||
            permission.contractSituation === false ||
            permission.permissionSituation === false ||
            permission.requestSituation === false ||
            permission.permitsSituation === false ||
            permission.additionalClauseSituation === false ||
            permission.exceptionSituation === false ||
            permission.trainingSituation === false ||
            permission.IMPACTSituation === false
    );
